module.exports = __webpack_public_path__ + "static/avatar@2x-5d22d7f00ce38117149575427113aca1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/handoff/avatar@2x.jpg
// module id = 2595
// module chunks = 168707334958949